export function adsKeyToI18nKey(adsKey) {
  if (!adsKey || typeof adsKey !== 'string') return 'PROPERTIES.VALUE';
  const snake = adsKey
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[-\s]+/g, '_')
    .toUpperCase();
  return `PROPERTIES.${snake}`;
}

export function formatUnit(adsKey) {
  if (typeof adsKey === 'string') {
    if (adsKey.endsWith('Level')) return '%';
    if (adsKey.endsWith('Temperature')) return '°C';
    if (adsKey.endsWith('Liters')) return 'L';
  }
  return '';
}

export function formatAdsValue(key, raw) {
  if (raw == null) return '–';
  let value = raw;
  if (typeof raw === 'string') {
    const n = Number(String(raw).replace(',', '.'));
    if (Number.isFinite(n)) value = n; else return raw;
  }
  if (typeof key === 'string') {
    if (key.endsWith('Level')) {
      const clamped = Number.isFinite(value) ? Math.max(0, Math.min(100, Number(value))) : null;
      return clamped != null ? `${Math.round(clamped)}${formatUnit(key)}` : '–';
    }
    if (key.endsWith('Temperature')) {
      return Number.isFinite(value) ? `${Number(value).toFixed(1)} ${formatUnit(key)}` : '–';
    }
    if (key.endsWith('Liters')) {
      return Number.isFinite(value) ? `${Number(value).toFixed(1)} ${formatUnit(key)}` : '–';
    }
  }
  return value != null ? String(value) : '–';
}

export function collectAdsKeysFromPositions(positions) {
  const set = new Set();
  if (Array.isArray(positions)) {
    positions.forEach((p) => {
      const ads = p && p.ads;
      if (ads && typeof ads === 'object') {
        Object.keys(ads).forEach((k) => set.add(k));
      }
    });
  }
  return Array.from(set);
}
